import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const MapSRPContainer = styled.div(
  ({ theme }) => `
  width: 100%;
  display: flex;
  margin-top: ${theme.spacing.large};
`
)

export const MapContainer = styled.div(
  ({ theme }) => `
  position: sticky;
  top: 7rem;
  height: 70vh;
  flex-basis: 100%;

  ${MEDIA_QUERIES(theme).medium} {
    height: calc(100vh - 7rem);
    flex-basis: 65%;
  }
`
)

export const LiveLocationWrapper = styled.div(
  ({ theme }) => `
  background: ${theme.colors.purple.light2};
  padding: ${theme.spacing.defaultSmall};
  margin-right: 1rem;
  border-radius: ${theme.borderRadius.small};
  margin-top: .5tem;
  display: flex;
  cursor: pointer;
`
)
